import React from "react"
import { Flex, Text } from "rebass"
import NumberFormat from "react-number-format"
export const LabelField = (props) => <Text fontSize={[0]} {...props} />

export const HeaderItemGridTOQ = (props) => {
  const {
    translate,
    toq,
    toa,
    styles = {},
    isBold = "normal",
    widthLabel = 160,
    widthValue = "80px",
  } = props
  return (
    <Flex
      width={[1]}
      flexDirection={"row"}
      p={[3]}
      justifyContent={"space-between"}
      style={styles}
    >
      <Flex
        width={[1]}
        pr={[2]}
        flexDirection={"row"}
        justifyContent={"flex-start"}
      >
        <LabelField fontWeight={isBold} style={{ width: widthLabel }}>
          {translate("resources.po.listgrid.total_order_qty")}
        </LabelField>
        <LabelField textAlign={"right"} width={widthValue}>
          {toq}
        </LabelField>
      </Flex>
      <Flex
        width={[1]}
        flexDirection={"row"}
        pl={[2]}
        justifyContent={"flex-start"}
      >
        <LabelField fontWeight={isBold} style={{ width: widthLabel }}>
          {translate("resources.po.listgrid.total_order_amt")}
        </LabelField>
        <LabelField textAlign={"right"} width={widthValue}>
          <NumberFormat
            value={toa}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
            decimalScale={2}
          />
        </LabelField>
      </Flex>
    </Flex>
  )
}

export const HeaderItemGridTPromo = (props) => {
  const {
    tPromoOrderAmt,
    tPromoOrderQty,
    labelPromoQty,
    labelPromoAmt,
    widthValue = "80px",
  } = props
  return (
    <Flex
      width={[1]}
      flexDirection={"row"}
      p={[3]}
      justifyContent={"space-between"}
      style={{ backgroundColor: "#F3F3F3" }}
    >
      <Flex
        width={[1]}
        flexDirection={"row"}
        justifyContent={"flex-start"}
        pr={[2]}
      >
        <LabelField fontWeight={"normal"} style={{ width: 160 }}>
          {labelPromoQty}
        </LabelField>
        <LabelField textAlign={"right"} width={widthValue}>
          {tPromoOrderQty}
        </LabelField>
      </Flex>
      <Flex
        width={[1]}
        flexDirection={"row"}
        justifyContent={"flex-start"}
        pl={[2]}
      >
        <LabelField fontWeight={"normal"} style={{ width: 160 }}>
          {labelPromoAmt}
        </LabelField>
        <LabelField textAlign={"right"} width={widthValue}>
          <NumberFormat
            value={tPromoOrderAmt}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
            decimalScale={2}
          />
        </LabelField>
      </Flex>
    </Flex>
  )
}
